import React from 'react';
import Avatar from '@atlaskit/avatar';
import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import { useIntl } from '@atlassian/jira-intl';
import ProfileCard from '@atlassian/jira-profilecard-next/src/ui/profilecard/sync-experiment.tsx';
import { VIEW_PROFILE_ACTION } from '@atlassian/jira-profilecard-next/src/common/constants.tsx';
import {
	ReadViewContainer,
	RoleContainer,
	RoleDisplayName,
	AvatarWrapper,
	RoleList,
	PlaceholderSpacer,
} from '../../common/ui/styled.tsx';
import { messages } from './messages.tsx';

type AccountId = string;

export type User = {
	accountId: AccountId;
	avatarUrl: string | undefined;
	displayName: string;
};

const UserReadViewWithProfileCard = ({
	accountId,
	avatarUrl,
	displayName,
}: {
	accountId: string;
	avatarUrl: string | undefined;
	displayName: string;
}) => (
	<ProfileCard accountId={accountId} actions={[VIEW_PROFILE_ACTION]}>
		<RoleContainer>
			<AvatarWrapper>
				{avatarUrl !== undefined ? (
					<Avatar appearance="circle" size="xsmall" src={avatarUrl} />
				) : (
					<PeopleGroupIcon label="" />
				)}
			</AvatarWrapper>
			<RoleDisplayName>{displayName}</RoleDisplayName>
		</RoleContainer>
	</ProfileCard>
);

export const UsersReadView = ({
	users,
	showPlaceholderIfEmpty = true,
}: {
	users: User[];
	showPlaceholderIfEmpty?: boolean;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();
	if (users.length === 0) {
		return (
			<ReadViewContainer isPlaceholder>
				<PlaceholderSpacer>
					{showPlaceholderIfEmpty ? formatMessage(messages.placeholder) : null}
				</PlaceholderSpacer>
			</ReadViewContainer>
		);
	}
	return (
		<ReadViewContainer isPlaceholder={false}>
			<RoleList>
				{users.map(({ accountId, avatarUrl, displayName }) => (
					<UserReadViewWithProfileCard
						key={accountId}
						accountId={accountId}
						avatarUrl={avatarUrl}
						displayName={displayName}
					/>
				))}
			</RoleList>
		</ReadViewContainer>
	);
};
